export default {
    setDirectorios(state, d) {
        state.directorios = d;
    },
    setCategoriasNegociosAsoc(state, c) {
        state.categoriasNegociosAsoc = c
    },
    setProductosNegociosAsoc(state, p) {
        state.productosNegociosAsoc = p;
    }
}